import EnhancedTable from '@common/components/Table/EnhancedTable'
import { HeadCell } from '@common/components/Table/table.types'
import { ReadTask } from '@common/config/api/client'
import { ROW_PER_PAGE_OPTIONS } from '@common/constants/table'
import { useParams } from 'react-router-dom'
import EnhancedTableBodyBlocked from './EnhancedTableBodyBlocked'
import { useUserList } from '@features/reader_task_list_iam_view/pages/hooks/useUserList'
import { useSearch } from '@common/hooks/useSeach'
import { useReadTasksManagementHandlers } from '../../hooks/useReadTasksManagementHandlers'

interface ReaderTaskListTableBlockedProps {
  subjectId?: string
}

const headCells: readonly HeadCell<ReadTask>[] = [
  { id: 'subject_id', disablePadding: false, label: 'Subject ID', disableSort: false },
  { id: 'blind_code', disablePadding: true, label: 'Blind code', disableSort: false },
  { id: 'timepoint_pseudo_name', disablePadding: false, label: 'Timepoint', disableSort: false },
  { id: 'task_pseudo_id', disablePadding: true, label: 'Task pseudo ID', disableSort: false },
  { id: 'task_type', disablePadding: false, label: 'Type', disableSort: false },
  { id: 'priority', disablePadding: false, label: 'Priority', disableSort: false },
  { id: 'status', disablePadding: false, label: 'Status', disableSort: false },
  { id: 'created_at', disablePadding: false, label: 'Created at', disableSort: false },
  { id: 'due_date', disablePadding: true, label: 'Due date', disableSort: false },
  { id: 'assignee', disablePadding: true, label: 'Assignee', disableSort: true },
]

export default function ReaderTaskListTableBlocked({ subjectId }: ReaderTaskListTableBlockedProps) {
  const { studyId } = useParams()
  const { value } = useSearch()

  const {
    order,
    orderBy,
    paginationParams,
    data,
    error,
    isLoading,
    handleRequestSort,
    handlePageChange,
    handleRowsPerPageChange,
  } = useReadTasksManagementHandlers({
    category: 'blocked_tasks',
    studyId: studyId!,
    subjectId,
    searchValue: value,
  })

  const {
    data: userListData,
    error: userListError,
    isLoading: UserlistLoading,
  } = useUserList(['ReaderTasksList', 'Users'], { study_id: studyId! })

  if (isLoading || UserlistLoading) {
    return <div>Loading...</div>
  }
  if (error || userListError) {
    return <div>Error: {(error && error.message) || (userListError && userListError.message)}</div>
  }

  return (
    <EnhancedTable
      rows={data?.data?.items || []}
      headCells={headCells}
      order={order}
      orderBy={orderBy.split('.')[0] as keyof ReadTask}
      rowsPerPage={paginationParams.limit || 0}
      rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      next_cursor={data?.data?.pagination.next_cursor}
      previous_cursor={data?.data?.pagination.previous_cursor}
      onRequestSort={handleRequestSort}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handleRowsPerPageChange}
    >
      <EnhancedTableBodyBlocked
        rows={data?.data?.items || []}
        order={order}
        orderBy={orderBy}
        assigneeList={userListData?.data?.users || []}
      />
    </EnhancedTable>
  )
}
